<div
  class="sticky bottom-0 bg-[var(--mat-bottom-sheet-container-background-color)] p-2 w-full flex justify-center"
>
  <button
    *ngIf="cancelText"
    class="!bg-[lightgray] !text-black w-[49%] p-2 mr-2 rounded-lg"
    (click)="onCancel.emit()"
  >
    {{ cancelText }}
  </button>
  <button
    class="!text-[var(--on-primary-color)] p-2 w-[49%] rounded-lg flex justify-center items-center grow"
    [disabled]="isSubmitting"
    [ngClass]="{
      '!bg-[var(--primary-color)]': !isSubmitting,
      '!bg-[lightgray]': isSubmitting
    }"
    (click)="onSubmit.emit()"
  >
    <span *ngIf="!isSubmitting">{{ submitText }}</span>
    <mat-spinner *ngIf="isSubmitting" class="!w-[20px] !h-[20px]"></mat-spinner>
  </button>
</div>
